export class UserInfo {
  constructor(public readonly username: string) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/auth/user-info.ts